import { render, staticRenderFns } from "./MyHoldings.vue?vue&type=template&id=b44023e0&scoped=true"
import script from "./MyHoldings.vue?vue&type=script&lang=js"
export * from "./MyHoldings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44023e0",
  null
  
)

export default component.exports